export default __webpack_public_path__ + "static/0071-ad3e0b624dadbf3f1587247777f3bd63.png";